module.exports = __webpack_public_path__ + "6408fc89eb241c3438b781ff0f1418ef.jpg";